"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries

/* ++++++++++ --------------- SEARCH : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'Search',
  props: {
    value: {
      type: 'string'
    },
    placeholder: {
      type: 'string',
      default: 'Search...'
    },
    handleFocus: {
      type: 'function',
      default: function _default() {
        return console.log('Focus');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    handleBlur: {
      type: 'function',
      default: function _default() {
        return console.log('Blur');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    onChange: {
      type: 'function',
      default: function _default() {
        return console.log('Change');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    dropfilter: {
      type: 'object',
      default: {
        alignment: 'left',
        onSelect: function onSelect(args) {
          return console.log(args);
        },
        items: [{
          value: 'first',
          name: 'first'
        }, {
          value: 'second',
          name: 'second'
        }],
        selectedItems: ['second'],
        title: 'Title',
        name: 'Name'
      }
    },
    searchresultnav: {
      type: 'object',
      default: {
        alignment: 'right',
        visible: true,
        clearResults: function clearResults() {
          return console.log('here');
        },
        handleResultsNav: function handleResultsNav(args) {
          return console.log(args);
        },
        currentResult: 16,
        resultsCount: 18
      }
    }
  }
};
exports.default = _default2;